import { z } from 'zod';

import { makeFeatureFlagPayloadValidator } from './utils';

const startingMessageSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  content: z.string(),
});

export const chatAgentPrompts = makeFeatureFlagPayloadValidator({
  schema: z.object({
    insightsChatPromptTemplateId: z.string().optional(),
    insightsChatModelName: z.string().optional(),
    insightChatStartingMessages: z.array(startingMessageSchema).optional(),
  }),
  defaultEnabled: false,
  defaultValue: {
    insightsChatPromptTemplateId: '',
    insightsChatModelName: 'claude-sonnet-4-5-20250929',
    insightChatStartingMessages: [],
  },
});
